<div class="align-center">
  <span mat-dialog-content style="margin-bottom: 20px;">
    <h3>Select Address</h3>
    <table>

      <caption></caption>
      <thead>
        <tr class="border-row">
          <th scope="col"></th>
          <th scope="col">First Name</th>
          <th scope="col">Last Name</th>
          <th scope="col">Address Line 1</th>
        </tr>
      </thead>
      <tbody>
        @for (option of options.addressesDto; track option) {
          <tr>
            <td>
              <mat-radio-group  class="example-radio-group">
                <mat-radio-button class="example-radio-button" [value]="option" (click)="optionSelected(option)" [checked]="option.checked">
                </mat-radio-button>
              </mat-radio-group>
            </td>
            <td>
              {{options.firstName}}
            </td>
            <td>
              {{options.lastName}}
            </td>
            <td>
              {{option.addressLine1}}
            </td>
          </tr>
        }
      </tbody>
    </table>


  </span>
  <div fxLayout="row" fxLayoutAlign="none center" fxLayoutGap="10px" fxLayout.xs="column" fxLayout.sm="column">
    <span class="controls-alignment"></span>
    <button mat-button class="controls-alignment" color="primary" type="button" (click)="close()">Cancel</button>
    <button mat-raised-button  class="controls-alignment" color="primary" [disabled]="!selectedOptionTemp" (click)="select()" type="button">Select</button>
    <span class="controls-alignment"></span>
  </div>
</div>